const getters = {
  footer: state => state.app.footer,
  logo: state => state.app.logo,
  categories: state => state.app.categories,
  width: state => state.app.width
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js